const $$splitComponentImporter = () => import('C:/Users/Administrator/new-api/web/default/src/routes/docs/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/docs/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});